import { forwardRef, type InputHTMLAttributes, useState } from 'react';
import { useTranslations } from 'use-intl';
import { cn } from '../../lib/utils';
import { Input } from './input';

/** Поле пароля с кнопкой «Показать» (ASVS 2.1.12): вставка разрешена, текст можно проверить. */
export const PasswordInput = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
>(function PasswordInput({ className, ...props }, ref) {
  const t = useTranslations('common');
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={cn('pr-24', className)}
        spellCheck={false}
        autoCapitalize="off"
        {...props}
      />
      <button
        type="button"
        aria-pressed={visible}
        onClick={() => setVisible(!visible)}
        className="absolute inset-y-1 right-1 rounded-sm px-3 text-sm font-medium text-ink hover:bg-surface-card"
      >
        {visible ? t('hidePassword') : t('showPassword')}
      </button>
    </div>
  );
});
